import {
    URLAPI,
    TYPE_NOVELTY_PATH,
    TYPE_NOVELTY_CREATE_PATH,
    TYPE_NOVELTY_UPDATE_PATH,
    TYPE_NOVELTY_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_type_novelty: {
        data: [],

        status: 0,
        message: {},
    },

    _create_type_novelty: {
        data: {},
        status: 0,
        message: {},
    },
    _update_type_novelty: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_type_novelty: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TYPE_NOVELTY = "GET_ALL_TYPE_NOVELTY";
export const CREATE_TYPE_NOVELTY = "CREATE_TYPE_NOVELTY";
export const UPDATE_TYPE_NOVELTY = "UPDATE_TYPE_NOVELTY";
export const DELETE_TYPE_NOVELTY = "DELETE_TYPE_NOVELTY";

export const type_novelty_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TYPE_NOVELTY:
            return {
                ...state,
                _get_all_type_novelty: action.payload,
            };
        case CREATE_TYPE_NOVELTY:
            return {
                ...state,
                _create_type_novelty: action.payload,
            };
        case UPDATE_TYPE_NOVELTY:
            return {
                ...state,
                _update_type_novelty: action.payload,
            };
        case DELETE_TYPE_NOVELTY:
            return {
                ...state,
                _delete_type_novelty: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTypeNovelty = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TYPE_NOVELTY_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TYPE_NOVELTY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TYPE_NOVELTY,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TYPE_NOVELTY,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create type_novelty
export const createTypeNovelty = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TYPE_NOVELTY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TYPE_NOVELTY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TYPE_NOVELTY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TYPE_NOVELTY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTypeNovelty = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TYPE_NOVELTY_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TYPE_NOVELTY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TYPE_NOVELTY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TYPE_NOVELTY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteTypeNovelty = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${TYPE_NOVELTY_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_TYPE_NOVELTY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_TYPE_NOVELTY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_TYPE_NOVELTY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_type_novelty = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
